var map = {
	"./br/PT/S1/bg147.jpg": 93548,
	"./br/PT/bg147.jpg": 23225,
	"./in/EN/S1/bg147.jpg": 10143,
	"./ph/EN/S1/bg147.jpg": 84865,
	"./ph/EN/bg147.jpg": 63140,
	"./vn/VI/S1/bg147.jpg": 27437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52296;